import moment from 'moment';
import {SortOrder, StudentAssignmentSortField} from 'gql/types';
import {useEffect, useMemo} from 'react';

import {addGenericErrorToast} from '@albert-io/atomic';
import type {
  // StudentAssignment,
  StudentAssignmentsFilters,
  StudentAssignmentsQueryVariables
} from '../StudentAssignment.types';
import {useStudentAssignmentsQuery} from '../queries/StudentAssignments.queries.generated';
import type {Value as DropdownValue} from '../AssignmentStatusDropdown';

const TO_DO_LIMIT = 15;

export default function useStudentAssignments(
  classroomId: string | undefined,
  dropdownValue: DropdownValue
) {
  const limit = dropdownValue === 'toDo' ? TO_DO_LIMIT : undefined;

  const filters = useMemo<StudentAssignmentsFilters>(() => {
    let ret: StudentAssignmentsFilters = {};

    if (classroomId !== undefined) {
      ret.classrooms = {
        id: {eq: classroomId}
      };
    }

    if (dropdownValue === 'closed') {
      ret.isOpen = {eq: false};
    } else if (dropdownValue === 'open') {
      ret.isOpen = {eq: true};
    } else if (dropdownValue === 'toDo') {
      ret.dueDate = {
        greaterThanOrEqual: moment().subtract(30, 'days').startOf('day').format(),
        lessThanOrEqual: moment().add(30, 'days').endOf('day').format()
      };
      ret.hasSubmitted = {eq: false};
      ret.isOpen = {eq: true};
    }

    return ret;
  }, [classroomId, dropdownValue]);

  const variables = useMemo<StudentAssignmentsQueryVariables>(
    () => ({
      filters,
      limit,
      sort: [
        {
          field: StudentAssignmentSortField.DueDateProximity,
          order: SortOrder.Asc
        }
      ]
    }),
    [filters, limit]
  );

  const {data, error, loading} = useStudentAssignmentsQuery({variables});

  useEffect(() => {
    if (error !== undefined) {
      addGenericErrorToast();
    }
  }, [error]);

  return {
    data,
    loading
  };
}
